export const convertBase64ToJSON = (base64Data:string) => {
    const padding = '='.repeat((4 - base64Data.length % 4) % 4);
    const base64 = (base64Data + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const uint8Array = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
        uint8Array[i] = rawData.charCodeAt(i);
    }
    const textDecoder = new TextDecoder('utf-8');
    const decodedData = textDecoder.decode(uint8Array);
    return JSON.parse(decodedData);
};

export const calculateFileSizeInMB = (base64String: string) => {
    try {
        if (base64String) {
            const base64WithoutHeader = base64String;
            const byteCharacters = atob(base64WithoutHeader);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);
        
            // Tamaño en Megabytes
            return blob.size / (1024 * 1024);
        }
        return 0;
    } catch (e) { return 0; }
};